import { Theme } from '@radix-ui/themes';
import { useSiteConfig, nearestRadixAccent } from '../../utils/siteConfig';
import { useThemeMode } from '../../utils/themeMode';

// Radix theme driven by the org's brandColor (Settings → Branding), mapped
// to the nearest Radix named accent. It must render inside a
// SiteConfigProvider. The root copy follows the Host org. The operator
// shell nests a second copy under an org-scoped provider, so the shell
// follows the signed-in org instead.
const BrandedTheme: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { get } = useSiteConfig();
  const { appearance } = useThemeMode();
  return (
    <Theme
      appearance={appearance}
      accentColor={nearestRadixAccent(get('brandColor', '#840032'))}
      grayColor="sand"
      radius="medium"
      scaling="100%"
    >
      {children}
    </Theme>
  );
};

export default BrandedTheme;
